import BaseController from '..';
import { company } from '../../../models/entities/company/company';

export type PlatformCompaniesListResponse = {
    data: company[];
    total: number;
};

export default class PlatformCompaniesController extends BaseController {
    constructor(baseUrl: string) {
        super(baseUrl);
    }

    async fetchCompanies(range?: [number, number]): Promise<PlatformCompaniesListResponse> {
        const query = range ? `?range=${JSON.stringify(range)}` : '';
        return this.client.get(`/super-admin/companies${query}`);
    }

    async fetchCompany(id: string): Promise<company> {
        return this.client.get(`/super-admin/companies/${id}`);
    }

    async createCompany(payload: Partial<company>): Promise<company> {
        return this.client.post('/super-admin/companies', JSON.stringify(payload));
    }

    async updateCompany(id: string, payload: Partial<company>): Promise<company> {
        return this.client.put(`/super-admin/companies/${id}`, JSON.stringify(payload));
    }
}
